<template>
    <span>{{ textName }}</span>
</template>

<script>
    export default {
        name: 'CellRendererName',
        computed: {
          textName() {
            return this.params.data.lname + ' ' + this.params.data.fname
          }
        },
    }
</script>
